import React from 'react';
import Grid from '@material-ui/core/Grid';
import MuiSkeleton from '@material-ui/lab/Skeleton';
import { withStyles } from '@material-ui/core/styles';

const Skeleton = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.neutrals.low.lightest
  },
  text: {
    transform: 'none',
  },
})) (MuiSkeleton);

export function SkeletonInfraDetails() {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Skeleton variant="text" width={'30%'} height={21} />
      </Grid>
      <Grid item xs={4}>
        <Skeleton variant="text" width={'100%'} height={21} />
      </Grid>
      <Grid item xs={3}>
        <Skeleton variant="text" width={'100%'} height={21} />
      </Grid>
      <Grid item xs={5}>
        <Skeleton variant="text" width={'100%'} height={21} />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={4}>
            <Skeleton variant="text" width={'100%'} height={21} />
          </Grid>
          <Grid item xs={3}>
            <Skeleton variant="text" width={'100%'} height={21} />
          </Grid>
          <Grid item xs={5}>
            <Skeleton variant="text" width={'100%'} height={21} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}